import styles from 'layouts/RealTimeDashboard/Service/TeamConversationsTable/styles.module.css'

export const getTableColumns = (
  columnLabels,
  columnWidths = {},
  columnAlignment = {},
  sortKey,
  sortDirection,
  setSortKey,
  setSortDirection
) => {
  return columnLabels.map((label, idx) => ({
    label,
    className: columnAlignment[idx] === 'right' ? styles.tar : '',
    width: columnWidths[idx],
    sortable: idx !== 0,
    sorting: sortKey === idx,
    direction: sortDirection,
    onClick: () => {
      if (idx !== 0) {
        setSortKey(idx)
        const dir =
          sortKey === idx ? (sortDirection === 'asc' ? 'desc' : 'asc') : 'desc'
        setSortDirection(dir)
      }
    },
  }))
}
export const getSortedTableData = (tableData, sortKey, sortDirection) => {
  return sortKey
    ? tableData.sort((a, b) => {
        // nulls/undefined sort after anything else
        if (a.data[sortKey].value === undefined) {
          return 1
        } else if (b.data[sortKey].value === undefined) {
          return -1
        } else if (sortDirection === 'desc') {
          return b.data[sortKey].value - a.data[sortKey].value
        } else {
          return a.data[sortKey].value - b.data[sortKey].value
        }
      })
    : tableData
}
